class NextDayDeliveryCountdown extends HTMLElement {
    constructor() {
        super();
        this.countdownInterval = null;
    }

    connectedCallback() {
        this.render();
        this.startCountdown();
        this.bindVariantChangeEvent();
        this.checkInitialVariant();
    }

    disconnectedCallback() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
        document.removeEventListener('variant:change', this.handleVariantChange);
    }

    bindVariantChangeEvent() {
        this.handleVariantChange = this.onVariantChange.bind(this);
        document.addEventListener('variant:change', this.handleVariantChange);
    }

    onVariantChange(event) {
        const variant = event.detail.variant;

        if (!variant) {
            this.hide();
            return;
        }

        // Hide countdown if variant is sold out
        if (!variant.available) {
            this.hide();
        } else {
            this.show();
        }
    }

    hide() {
        this.style.display = 'none';
    }

    show() {
        this.style.display = 'block';
    }

    checkInitialVariant() {
        // Check if there's a selected variant on page load
        const variantSelect = document.querySelector('[data-product-select]');
        if (variantSelect) {
            const selectedOption = variantSelect.options[variantSelect.selectedIndex];
            if (selectedOption && selectedOption.disabled) {
                this.hide();
            }
        }

        // Check for sold out button
        const addToCartBtn = document.querySelector('[data-add-to-cart]');
        if (addToCartBtn && addToCartBtn.disabled) {
            this.hide();
        }
    }

    getNextDeliveryInfo() {
        const now = new Date();
        const ukTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/London" }));

        const currentDay = ukTime.getDay();
        const currentHour = ukTime.getHours();
        const currentMinute = ukTime.getMinutes();

        const currentTimeInMinutes = currentHour * 60 + currentMinute;
        const cutoffTimeInMinutes = 15 * 60;

        let deliveryDay = '';
        let cutoffDate = new Date(ukTime);

        if (currentDay >= 1 && currentDay <= 5) {
            // Weekday (Monday to Friday)
            if (currentTimeInMinutes < cutoffTimeInMinutes) {
                const nextDay = new Date(ukTime);
                nextDay.setDate(nextDay.getDate() + 1);
                deliveryDay = this.getDayName(nextDay.getDay());

                cutoffDate.setHours(15, 0, 0, 0);
            } else {
                // After 3 PM on weekday
                if (currentDay === 5) {
                    deliveryDay = 'Tuesday';
                } else {
                    const dayAfterTomorrow = new Date(ukTime);
                    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
                    deliveryDay = this.getDayName(dayAfterTomorrow.getDay());
                }

                const nextWorkingDay = new Date(ukTime);
                if (currentDay === 5) {
                    nextWorkingDay.setDate(nextWorkingDay.getDate() + 3);
                } else {
                    nextWorkingDay.setDate(nextWorkingDay.getDate() + 1);
                }
                nextWorkingDay.setHours(15, 0, 0, 0);
                cutoffDate = nextWorkingDay;
            }
        } else {
            deliveryDay = 'Tuesday';

            const daysUntilMonday = currentDay === 0 ? 1 : 2;
            cutoffDate.setDate(cutoffDate.getDate() + daysUntilMonday);
            cutoffDate.setHours(15, 0, 0, 0);
        }

        return { deliveryDay, cutoffDate };
    }

    getDayName(dayNumber) {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return days[dayNumber];
    }

    calculateTimeRemaining(cutoffDate) {
        const now = new Date();
        const ukNow = new Date(now.toLocaleString("en-US", { timeZone: "Europe/London" }));

        const timeDiff = cutoffDate.getTime() - ukNow.getTime();

        if (timeDiff <= 0) {
            return null;
        }

        const hours = Math.floor(timeDiff / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

        return { hours, minutes };
    }

    updateCountdownDisplay() {
        const { deliveryDay, cutoffDate } = this.getNextDeliveryInfo();
        const timeRemaining = this.calculateTimeRemaining(cutoffDate);

        const messageElement = this.querySelector('.delivery-countdown-message');

        if (timeRemaining && timeRemaining.hours > 0) {
            // Show countdown
            const hoursText = timeRemaining.hours === 1 ? 'Hr' : 'Hrs';
            const minutesText = timeRemaining.minutes === 1 ? 'Min' : 'Mins';

            messageElement.innerHTML = `<span class="truck-icon">⛟</span> Want it ${deliveryDay}? <span class="countdown-time">Order Within ${timeRemaining.hours} ${hoursText} ${timeRemaining.minutes} ${minutesText}</span>`;
        } else {
            const minutesText = timeRemaining.minutes === 1 ? 'Min' : 'Mins';

            messageElement.innerHTML = `<span class="truck-icon">⛟</span> Want it ${deliveryDay}? <span class="countdown-time">Order Within ${timeRemaining.minutes} ${minutesText}</span>`;
            messageElement.classList.add('active-countdown');
        }
    }

    startCountdown() {
        this.updateCountdownDisplay();

        this.countdownInterval = setInterval(() => {
            this.updateCountdownDisplay();
        }, 60000);
    }

    render() {
        this.innerHTML = `
      <div class="next-day-delivery-countdown">
        <div class="delivery-countdown-message"></div>
      </div>
    `;
    }
}

// Register the custom element
customElements.define('next-day-delivery-countdown', NextDayDeliveryCountdown);